import { type FirebaseApp, initializeApp } from "firebase/app";
import { type Auth, GoogleAuthProvider, getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_EMPLOYEE_INTERVIEW_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_EMPLOYEE_INTERVIEW_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_EMPLOYEE_INTERVIEW_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_EMPLOYEE_INTERVIEW_FIREBASE_APP_ID,
};

const firebaseApp: FirebaseApp = initializeApp(firebaseConfig);
const firebaseAuth: Auth = getAuth(firebaseApp);

export const googleProvider = new GoogleAuthProvider();
// Google カレンダー連携は別フロー（mutation 経由の OAuth）に切り出しているため、
// ログイン時の Firebase Provider 側ではユーザー情報のみを要求する。
googleProvider.addScope("email");
googleProvider.addScope("profile");

export { firebaseApp, firebaseAuth };
